import { useState, useEffect, useMemo } from "react";
import { getLegalTextBySponsor } from '../../functions/functions.js';
import WidgetContainer from "./reusablesComponents/containerWidget.js";
import Carrousel from "./reusablesComponents/carrousel.js";
import NoEvents from "./noEvents/noEvents.js";
import Legal from "./legal/legal.js";
import "./carrouselTeam.sass";

/** 
 * Muestra un carrusel con todos los partidos (calendario y resultados) en una sola vista.
 */
export default function CarrouselTeam({ patrocinador: sponsor, flagMomios, dataGames }) {
  const [loading, setLoading] = useState(true);

  const legalText = getLegalTextBySponsor(sponsor);
  const activeMomios = flagMomios === true || flagMomios === "true";

  const sortedData = useMemo(() =>
    [...(dataGames || [])].sort((a, b) => new Date(a.utc_date) - new Date(b.utc_date)),
    [dataGames]
  );

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <WidgetContainer loading={loading} heightLoading={135} className="container__carrousel-team" id="container__carrousel-team">
      <div className="carrousel-team__left-middle-right">
        {sortedData.length === 0
          ? <NoEvents type={135} />
          : <Carrousel
            data={sortedData}
            cardWidth={135}
            activeMomios={activeMomios}
            loading={loading}
            patrocinador={sponsor}
            classCarrousel="carrousel-card-team"
            classPrefix="carrousel-team-right"
            indexJson={1}
          />
        }
      </div>

      {/* mostrar leyenda de copy legal */}
      {activeMomios && !loading && legalText.trim().length > 0 && (
        <Legal patrocinador={sponsor} />
      )}
    </WidgetContainer>
  )
}
